import { Map, View } from 'ol';
import { Vector as VectorLayer, Group as LayerGroup } from 'ol/layer';
import { KML } from 'ol/format';
import { Vector as VectorSource } from 'ol/source';
import { defaults as defaultControls, ScaleLine } from 'ol/control';
import * as olExtent from 'ol/extent';
import { fromLonLat } from 'ol/proj';
import { apply } from 'ol-mapbox-style';
import { XMLParser } from 'fast-xml-parser';
import { PopupOverlay } from '../shared/nhc-modules/map-popups';
import { BaseMapToggle } from '../shared/nhc-modules/basemap-toggle';
import './style.css';

let url, staticUrl, stormName, advNum, dateTime;

// We create this object to pass to the popupOverlay.
// This data is not used anywhere else in this file.
const checks = {
  "watchWarn": {
    "sort": 1,
    "divId": "",
    "label": "Storm Surge Watch/Warning",
    "labelShort": "SS Watch/Warning",
    "checked": true,
    "layerId": "",
    "lineEnd": false,
    "format": "KML",
    "idStr": "WatchWarningSS"
  }
};

/**
 * To handle async loading of the XML file, we wrap the main code in an 
 * async "Immediately Invoked Function Expression" (IIFE). Any code that
 * uses data from the XML file needs to be inside the IIFE.
 */
(async () => {
  // Load the XML file
  const xmlData = await getXmlData(xmlFile);

  url = xmlData.meta.url;
  staticUrl = xmlData.meta.staticurl;
  stormName = xmlData.meta.stormName;
  advNum = xmlData.meta.advNum;
  dateTime = xmlData.meta.dateTime;

  const mapCenter = fromLonLat([-82.0, 29.0]);

  /**
   * Define the scale bar control
   */
  const scaleBar = new ScaleLine({
    units: "imperial",
    bar: true,
    target: document.getElementById("scalebar")
  });

  /**
   * Define the popup overlay
   */
  const popupOverlay = new PopupOverlay({
    element: document.getElementById('popup'),
    autoPan: {
      animation: {
        duration: 250,
      },
    },
    labelSource: checks,
  });

  /**
   * Create an ESRI basemap layer group (Light Gray)
   */
  const grayLayer = new LayerGroup();
  const apiKey = import.meta.env.VITE_ESRI_API_KEY;
  let basemapId = "arcgis/dark-gray";
  let basemapURL = `https://basemapstyles-api.arcgis.com/arcgis/rest/services/styles/v2/styles/${basemapId}?token=${apiKey}`;
  apply(grayLayer, basemapURL);

  /**
   * Create an ESRI basemap layer group (Imagery Hybrid)
   */
  const hybridLayer = new LayerGroup();
  basemapId = "arcgis/imagery";
  basemapURL = `https://basemapstyles-api.arcgis.com/arcgis/rest/services/styles/v2/styles/${basemapId}?token=${apiKey}`;
  apply(hybridLayer, basemapURL);

  /**
   * Create the watch/warning layer
   */
  const watchWarnLayer = new VectorLayer({
    source: new VectorSource({
      url: url.replace("https://www.nhc.noaa.gov", ""),
      format: new KML(),
    }),
    visible: false,
  });

  /**
   * Define the base map toggle control
   */
  const baseMapToggle = new BaseMapToggle({
    startLayer: grayLayer,
    startLayerName: 'Dark Gray Canvas',
    startLayerImage: '/images/dark-gray.jpg',
    nextLayer: hybridLayer,
    nextLayerName: 'Imagery with Labels',
    nextLayerImage: '/images/hybrid.jpg'
  });

  /**
   * Define the main map object
   */
  const map = new Map({
    controls: defaultControls().extend([
      scaleBar,
      baseMapToggle
    ]),
    layers: [
      grayLayer,
      watchWarnLayer
    ],
    overlays: [popupOverlay],
    target: document.getElementById('map'),
    view: new View({
      center: mapCenter,
      projection: 'EPSG:3857',
      zoom: 6,
    }),
  });

  /**
   * Once the DOM is loaded and the page is ready...
   */
  $(function() {
    // Fill in data on the heading
    $("#stormName").text(stormName);
    $("#advNum").text(advNum);
    $("#dateIssued").text(dateTime);
    $("#staticUrl").attr("href", staticUrl);
    // Create the dialog
    $("#dialogdiv").dialog({
      append: "#map-canvas",
      modal: true,
      resizable: false,
      open: function(event, ui) {
        $(".ui-dialog-titlebar-close").hide();
      },
      draggable: true,
      buttons: {
        "I Understand": function() {
          $( this ).dialog( "close" );
          watchWarnLayer.setVisible(true);
          autoZoom();
        },
        "Return to NHC Homepage": function() {
          document.location.href='http://www.nhc.noaa.gov';
        }
      }
    });
    var dialog=$('.ui-dialog');
    $('#dialogdiv').parent().position({my: 'center', at: 'center', of: '#map'});
    dialog.draggable("option", "containment", "#map-canvas");
  });


  // ================================================
  // Support functions
  // ================================================

  /**
   * Auto-zoom the map to the watch/warning's extent
   */
  function autoZoom() {
    // Get the cone layer
    let source = watchWarnLayer.getSource();
    // To ensure that the source is loaded, we listen for the source
    // to change (which includes when it finishes loading)
    source.on('change', function () {
      // Then we check if the source is ready
      if (source.getState() === 'ready') {
        let wwExtent = source.getExtent();
        // Only zoom if the extent is not empty
        if (wwExtent && !olExtent.isEmpty(wwExtent)) {
          // Expand the extent by a factor of 2
          olExtent.scaleFromCenter(wwExtent, 2);
          let view = map.getView();
          let resolution = view.getResolutionForExtent(wwExtent);
          let zoom = view.getZoomForResolution(resolution);
          view.animate({
            duration: 700, // Duration in milliseconds
            center: olExtent.getCenter(wwExtent),
            zoom: zoom
          });
        }
      }
    });
  }

})();

/**
 * Load the XML file. xmlFile is set in the HTML file.
 * @param {string} xmlFile The path to the XML file
 * @returns {object} The parsed XML data
 */
async function getXmlData(xmlFile) {
  const parser = new XMLParser();
  const xmlData = await fetch(xmlFile)
    .then(response => response.text())
    .then(data => parser.parse(data));
  return xmlData;
}
